<template>
  <div id="newsItem">

    <div class="o-modal">
      <div class="o-modal-content big">
        <div class="o-modal-header">
          <a
            @click="closeNewsItem"
            class="close clickable"
          ><i class="fas fa-times"></i></a>
          <p class="lead">Portfolio newsItem</p>
        </div><!-- /.o-modal-header -->
        <div class="o-modal-body">
          <h2>{{ newsItem.title }}</h2>
          <div class="row">
            <div class="col-md-12">
              <transition name="fade">
                <div
                  v-if="loading == true"
                  class="spinner d-flex justify-content-center"
                  style="padding-top:50px;"
                >
                  <b-spinner style="width: 5rem; height: 5rem;" label="Loading..."></b-spinner>
                </div>
              </transition>
              <b-carousel
                v-if="gallery.length > 0"
                controls
                indicators
                id="carousel"
                img-width="1024"
                img-height="480"
                class="mb-2 min-height"
              >
                <b-carousel-slide
                  v-for="image in gallery"
                  v-bind:key="image.url"
                  :img-src="image.url"
                ></b-carousel-slide>
              </b-carousel>
              <img
                v-if="gallery.length == 0"
                :src="newsItem.featured_image"
                class="w-100"
              />
            </div><!-- /.col-md-6 -->
            <div class="col-md-12">
              <div
                v-html="newsItem.body"
              >
              </div>
            </div><!-- /.col-md-6 -->
          </div><!-- /.row -->
        </div><!-- /.o-modal-body -->
      </div><!-- /.o-modal-content -->
    </div><!-- /.o-modal -->

  </div><!-- /#newsItem -->
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      loading: true,
      gallery: [],
      showUnits: false,
      units: false
    }
  },
  props: [
    'newsItem'
  ],
  created() {
    let timeStamp = new Date().getTime()
    let nid = this.newsItem.nid
    axios.get('https://buffalofts.com/api/portfolio/gallery?nid=' + nid + '&timestamp=' + timeStamp).then(response => {
      this.gallery = response.data
      this.loading = false
    })
  },
  methods: {
    getUnits(nid) {
      this.loading = true
      this.units = false
      this.showUnits = true
      let timeStamp = new Date().getTime()
      axios.get('https://buffalofts.com/api/portfolio/units?nid=' + nid + '&timestamp=' + timeStamp).then(response => {
        this.units = response.data
        this.loading = false
      })
    },
    closeNewsItem() {
      this.$emit('closeNewsItem')
    }
  }
}
</script>

<style>
#newsItem {
  position: relative;
}
.min-height {
  min-height: 200px;
}
h2 {
  font-size: 24px;
}
#available-units {
  position: absolute;
  top: 50px;
  bottom: 00px;
  background-color: #eee;
  left: 0px;
  right: 0px;
  padding: 20px 30%;
  z-index: 15;
  overflow: scroll;
}
.price {
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3);
  background-color: #333;
  color: #fff;
  font-weight: bold;
  padding: 3px 8px;
  border-radius: 2px;
  position: absolute;
  top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/NewsItem.vue